import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      <p class="mb-3">
        …и тогда началось активное производство кукол во всепланетном масштабе. 
        Сначала это были только куклы-самки с длинными распущенными волосами и семью различными калибрами половой щели. 
        Однако вскоре и «женщины» (второй пол в двуполой системе жизни на планете) захотели тех же преимуществ и удобств, 
        какие давало наличие всегда готового партнёра. 
        Ещё раньше начали выпускать вибраторы, представляющие собой один «мужской» половой орган, всегда одинаковой толщины и длины; 
        и «женщине» приходилось всегда самой держать его в руках при использовании, что было явно неудобно и не создавало иллюзии «любовного акта». 
      </p>
      
      <p class="mb-3">
        Но появление кукол-самок с «мягкой горячей кожей, которую можно было даже пересаживать людям при операциях, и она приживалась», 
        стало поворотным пунктом в этой эпопее. 
        Самки захотели тоже тёплой кожи и горячих объятий. 
      </p>
      
      <p class="mb-3">
        Куклы-самцы тоже выпускались по калибрам: но кроме длины и толщины, можно было также регулировать твёрдость, а также ритм и частоту колебаний. 
        И что важно, робот-самец с горячей кожей и мягкими руками также обнимал и ласкал, и мог шептать на ухо разные, по желанию заказчицы, слова. 
        Куда же было с ним сравниться жалким живым копиям этого совершенного партнёра!
      </p>
      
      <p class="mb-3">
        Кроме того, куклы-самцы могли выполнять и другие функции. 
        Их скоро приспособили к лечебным и косметическим целям. 
        Разумеется, в нужном месте туловища у робота находился мешочек со смазкой, т.е. безвредной любрикатной жидкостью, 
        которая выделялась также при имитации оргазма. 
        Однако самки быстро догадались, что в этот резервуар можно заливать средства не только для непосредственно полового акта, но и, например, 
        лекарственные растворы для спринцевания, витаминные смеси, да и просто благоуханные отдушки, 
        чтобы самка уже со всех своих концов издавала приятные ароматы. 
        Кого привлекать? Живых самцов? Да кому они нужны! 
        Это было соревнование среди самок.
      </p>
      
      <p class="mb-3">
        Таким образом, перестроилась и парфюмерная, и фарм-промышленность: всё больше их продукции предназначалось для инкорпорального введения. 
        В обществе с доминацией самцов эта возможность даже не рассматривалась; но когда начали ею заниматься, 
        открылись новые, совершенно неожиданные перспективы. 
        Оказалось, что после небольшой операции даже питание можно вводить в организм «через низ». 
        Это привело ещё к одному кардинальному изменению в образе жизни населения: полностью перестроилась пищевая промышленность, 
        частично слившись с фармацевтикой; питание теперь стало сбалансированным по всем показателям, 
        а на планете прекратилось выращивание скота на убой и засевание растительными монокультурами огромных площадей. 
        Биотоп планеты пришёл в равновесие, и другие разумные существа, ранее прятавшиеся в укромных местах или на дне океана, получили право на жизнь. 
      </p>
      
      <p class="mb-3">
        А у самок, «единственного разумного вида», ввиду изменения способа питания, дегенерировал обширный пищеварительный аппарат, 
        и внутри тела освободилось много места. 
        Да и само тело умеьшилось, т.к. уже не требовало больших порций грубой пищи. 
      </p>
      
      <p class="mb-3">
        А что же другой пол двуполой системы, т.н. «мужчины»? 
        Разумеется, они не собирались расставаться со своими привилегиями; но разве можно остановить эволюцию? 
        Освобождённые от зависимости от самцов, самки необычайно быстро, неудержимо стали развивать новые области науки, 
        преимущественно связанные с природой, фактически прекратив машинную цивилизацию. 
        Самцы как отдельные существа практически перестали быть нужными для продолжения жизни, 
        т.к. у них можно было просто взять оплодотворяющее вещество и ввести его в самца-куклу. 
      </p>
      
      <p class="mb-3">
        И тогда кто-то из самок совершил решающий шаг: путём генной инженерии из отчаявшихся, никому не нужных самцов, 
        которые не могли найти себе место в жизни и массово самоубивались, были выделены гонады и перенесены в освободившееся место в теле самки. 
        Так «разумное население» планеты было спасено от полного вымирания: тела самцов иссохли и исчезли с лица планеты, 
        а их половые органы были теперь надёжно укрыты в теле самок. 
        Это был второй этап эволюции жизни на подобном типе планет: сначала внутреннее оплодотворение и вынашивание плода в теле самки; 
        затем затем помещение туда же и противоположного пола, чтобы избежать невстречи и бесплодия, чтобы жизнь продолжалась.
      </p>
      
      <p class="mb-3">
        Рождаются, как и положено, мальчики и девочки; у новорожденных мальчиков берут половой аппарат и пересаживают его в организм новорожденных девочек, 
        где оба растут и развиваются вместе. 
        Это и есть «мужской паразитизм» в его биологическом смысле. 
        По достижении половой зрелости организмы начинают размножаться по собственному желанию. 
      </p>
      
      <p class="mb-5">
        Единственное, чего мы не смогли выяснить – это что делают с телами новорожденных мальчиков. 
        Но надеемся, что дальнейшие исследования дадут ответ и на этот вопрос. 
      </p>
 
      <table class="mb-5" style="width: 100%;">
        <tbody>
          <tr>
            <td style="text-align: left;">
              <div style="padding-left: 30px;">
                Пилот: ()
              </div>
            </td>
            <td style="text-align: right;">
              <div style="padding-right: 30px;">
                Дата: ()
              </div>
            </td>
          </tr>
        </tbody>
      </table>
 
      <p class="mb-5">
        Рассказ основан на двух цитатах из Ст. Лема
      </p>

    </div>
    `
  )
}

const itemName = {
  rus: `Отрывок из чудом сохранившегося специального рапорта пилота () Космического Контроля, посетившего планету 3864 через 42 гунгма для внеочередной проверки`
}

const itemDate = {
  rus: `14 сентября 2021 г.`
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;